import type { ResolveDesignationsResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useResolveDesignations(roleId: null | number | undefined) {
  return useQuery({
    enabled: !!roleId,
    queryFn: () =>
      apiClient
        .url(`/users/resolve-designations`)
        .query({ roleId })
        .get()
        .json<ResolveDesignationsResponse>(),
    queryKey: ["resolve-designations", roleId],
  });
}
